var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgPlus = function SvgPlus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 3.515a.75.75 0 0 0-1.5 0v7.735H3.515a.75.75 0 0 0 0 1.5h7.735v7.735a.75.75 0 0 0 1.5 0V12.75h7.735a.75.75 0 0 0 0-1.5H12.75V3.515Z"
  })));
};

export default SvgPlus;